import { render, staticRenderFns } from "./StudentChangePassword.vue?vue&type=template&id=9b89784a&scoped=true"
import script from "./StudentChangePassword.vue?vue&type=script&lang=js"
export * from "./StudentChangePassword.vue?vue&type=script&lang=js"
import style0 from "./StudentChangePassword.vue?vue&type=style&index=0&id=9b89784a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b89784a",
  null
  
)

export default component.exports